import { defineAbility } from '@casl/ability';

const ability = defineAbility(() => {});

export default ability;
